import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Suggest_Interface } from 'src/app/Interface/Suggest_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SuggestService {

  constructor(private http:HttpClient) { }


  GetRecord(Token:String):Observable<Array<Suggest_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Suggest?token="+Token).pipe(
      map(data=>{
        return data as Array<Suggest_Interface>
      })
    )
  }

  GetReport(Token: String,
    StartSearchDate: String,
    EndSearchDate:String,
    period:number,
    username:String):Observable<Array<Suggest_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Suggest/GetReport?token=" + Token
    +"&period="+period
    +"&username="+username
    +"&startdate="+StartSearchDate
    +"&enddate="+EndSearchDate).pipe(
      map(data=>{
        return data as Array<Suggest_Interface>
      })
    )
  }

  GetOperation(Token:String,id:number):Observable<Array<Suggest_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Suggest/GetOperation?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Array<Suggest_Interface>
      })
    )
  }

  uploadFile(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Suggest/Upload?token="+Token,body).pipe(
      map(data=>{

        return data
      })
    )
  }

  SubmitTicket(message: string,
    dsc: string,
    id: number,
    title_id: number,
    order_id: number,
    point: number,
    Token: String,
    file: Array<string>): Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var model = {
      id:id,
      title_id:title_id,

    }

    var body={
      model:model,
      message:message,
      dsc:dsc,
      point:point,
      order_id:order_id,
      token:Token,
      files:file
    }


      return this.http.post(environment.BaseUrl + "Daro/Suggest/SubmitSuggest",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
      )

  }

}
